import { transactionManager } from '../core/txn/TransactionManager';
import { useCallback, useRef } from 'react';

const DELAY = 1000;

export const useTransaction = ({ onTransactionChange = () => {} }) => {
  const transactionQueueRef = useRef([]);
  const debounceRef = useRef(null);

  const dispatchTransaction = useCallback(
    (txn) => {
      transactionQueueRef.current = [...transactionQueueRef.current, ...txn];
      if (debounceRef.current) clearTimeout(debounceRef.current);
      debounceRef.current = setTimeout(async () => {
        const txnsToProcess = [...transactionQueueRef.current];
        transactionQueueRef.current = [];
        const savedTxns = await transactionManager.processTransactionInBatches(txnsToProcess);
        onTransactionChange({ transactions: savedTxns });
      }, DELAY);
    },
    [onTransactionChange]
  );

  return { dispatchTransaction };
};
